import Translate from './Translate'
import TranslateProvider from './TranslateProvider'
import reactTranslateChangeLanguage from './reactTranslateChangeLanguage'

export default Translate
export { TranslateProvider, reactTranslateChangeLanguage }
